import React, { ButtonHTMLAttributes } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useLightboxState } from "yet-another-react-lightbox";
import FacebookIcon from "@mui/icons-material/Facebook";
import XIcon from "@mui/icons-material/X";
import SendRoundedIcon from "@mui/icons-material/SendRounded";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  filenames: string[];
  identity: string[];
}

const ShareButton: React.FC<ButtonProps> = ({
  filenames,
  identity,
  ...rest
}) => {
  const [open, setOpen] = React.useState(false);
  const { currentIndex } = useLightboxState();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  async function getImageUrl(imageid: string) {
    try {
      // Submit the body to the API
      const res = await fetch("/api/getImageUrl", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: "discover@raraity.com",
          id: imageid,
        }),
      });

      // Get the status code from the response
      const statusCode = res.status;

      // Wait for the JSON response
      const response = await res.json();

      // Return status code and response
      return { statusCode, data: response };
    } catch (error) {
      if (error instanceof Error) {
        console.error(error.message);
      } else {
        console.error(error);
      }
      // Return status code and error
      return { statusCode: 500, error };
    }
  }

  const shareOnFacebook = async () => {
    const filename = filenames[currentIndex];
    let imageurl: string;
    const result = await getImageUrl(filename);
    const { statusCode, data, error } = result;

    if (statusCode === 200) {

      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      imageurl = data;
    } else {
      console.error("Error:", error);
    }

    // Open the Facebook share dialog
    const navUrl =
      process.env.NEXT_PUBLIC_ENVIRONMENT === "prod"
        ? `https://www.facebook.com/sharer/sharer.php?u=https://raraity.com/discover?id=${identity[currentIndex]}/${filename}`
        : `https://www.facebook.com/sharer/sharer.php?u=https://dev.raraity.com/discover?id=${identity[currentIndex]}/${filename}`;
    console.log(navUrl);
    window.open(navUrl, "_blank");
  };

  const shareOnTwitter = async () => {
    const filename = filenames[currentIndex];
    let imageurl: string;
    const result = await getImageUrl(filename);
    const { statusCode, data, error } = result;

    if (statusCode === 200) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      imageurl = data;
    } else {
      console.error("Error:", error);
    }
    const navUrl =
      process.env.NEXT_PUBLIC_ENVIRONMENT === "prod"
        ? `https://twitter.com/intent/tweet?text=https://raraity.com/discover?id=${identity[currentIndex]}/${filename}`
        : `https://twitter.com/intent/tweet?text=https://dev.raraity.com/discover?id=${identity[currentIndex]}/${filename}`;
    console.log(navUrl);
    window.open(navUrl, "_blank");
  };

  return (
    <>
      <button
        type="button"
        id="share"
        onClick={handleClickOpen}
        {...rest}
        className="share-button"
      >
        <SendRoundedIcon className="ShareButton" />
        <span className="tooltip">Click to share</span>
        <style>{`
        .ShareButton {
          color: black;
          border: none;
          border-radius: 4px;
          cursor: pointer;
        }

        .ShareButton:hover {
          color: 	#D3D3D3;
        }

        .share-button {
          position: relative; /* Add relative positioning */
          color: black;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          padding-top: 10px;
          padding-bottom: 10px;
          padding-right: 15px;
          padding-left: 15px;
        }

        @media (min-width: 600px) {
          .ShareButton {
            height: 36px;
            width: 36px;
            color: black;
            border: none;
            border-radius: 4px;
            cursor: pointer;
          }
          .share-button {
            padding-top: 10px;
            padding-bottom: 10px;
            padding-right: 15px;
            padding-left: 15px;
          }
        }

        .tooltip {
          position: absolute;
          bottom: 50px;
          left: 50%;
          transform: translateX(-50%);
          background-color: rgba(0, 0, 0, 0.7);
          color: #D3D3D3;
          padding: 5px;
          border-radius: 4px;
          font-size: 14px;
          white-space: nowrap; /* Prevent tooltip text from wrapping */
          width: auto; /* Adjust the width as needed */
          min-width: 100px; /* Set a minimum width to avoid being too narrow */
          text-align: center; /* Center the text horizontally */
          opacity: 0;
          visibility: hidden;
          transition: opacity 0.3s, visibility 0.3s;
        }

        .share-button:hover .tooltip {
          opacity: 1;
          visibility: visible;
        }

      `}</style>
      </button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{ zIndex: 10000 }}
      >
        <DialogTitle id="alert-dialog-title">Share</DialogTitle>
        <DialogContent>
          <div className="flex flex-col gap-2">
            <button
              style={{ backgroundColor: "rgb(24, 119, 242)", color: "white" }}
              className="h-14 text-l font-bold p-4"
              onClick={shareOnFacebook}
              type="button"
            >
              <FacebookIcon sx={{ color: "white", paddingRight: "4px" }} />
              Share on Facebook
            </button>
            <button
              style={{ backgroundColor: "rgb(80, 171, 241)", color: "white" }}
              className="h-14 text-l font-bold p-4"
              onClick={shareOnTwitter}
              type="button"
            >
              <XIcon sx={{ color: "white", paddingRight: "4px" }} />
              Share on Twitter
            </button>
          </div>
          {/* <DialogContentText id="alert-dialog-description">
            Let Google help apps determine location. This means sending
            anonymous location data to Google, even when no apps are running.
          </DialogContentText> */}
        </DialogContent>
        {/* <DialogActions>
        </DialogActions> */}
      </Dialog>
    </>
  );
};

export default ShareButton;
